import { useCallback, useMemo } from "react";
import {
  IconButton,
  ButtonBase,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import PageBox from "../../../components/PageBox/PageBox.component";
import styles from "./Style.module.css";
import DataTables from "../../../Datatables/Datatable.table";
import Constants from "../../../config/constants";
import FilterComponent from "../../../components/Filter/Filter.component";
import { Add, Edit } from "@material-ui/icons";
import StatusPill from "../../../components/Status/StatusPill.component";
import usePrimaryUserUpdateListHook from "./PrimaryUserUpdate.hook";

const PrimaryUserUpdateListView = () => {
  const {
    handleSortOrderChange,
    handleRowSize,
    handlePageChange,
    handleEdit,
    handleFilterDataChange,
    handleSearchValueChange,
    handleCreateFed,
    isCalling,
    handleViewUpdate,
    handleOpenCategory,
  } = usePrimaryUserUpdateListHook({});

  const {
    data,
    all: allData,
    currentPage,
    is_fetching: isFetching,
    query,
  } = useSelector((state) => state.primary_user_update);

  const renderStatus = useCallback((status) => {
    return (
      <StatusPill
        status={status}
        style={status === "PROCESSED" && { background: "#ceece2" }}
      />
    );
  }, []);

  const renderFirstCell = useCallback((obj) => {
    if (obj) {
      console.log(obj);
      return (
        <div className={styles.firstCellFlex}>
          <div className={styles.firstCellInfo}>
            <div>
              <img src={obj?.img_url} />
            </div>
            <div>
              {/* <span className={styles.productName}>{obj?.name}</span> <br /> */}
              <a
                href={obj?.url}
                target="_blank"
                className={styles.hyperlinkText}
                rel="noreferrer"
              >
                {obj?.url}
              </a>
              {/* <span >{obj?.url}</span> <br /> */}
            </div>
          </div>
        </div>
      );
    }
    return null;
  }, []);

  const tableStructure = useMemo(() => {
    return [
      {
        key: "name",
        label: "COMPANY NAME",
        sortable: false,
        render: (value, all) => <div>{all?.name}</div>,
      },
      {
        key: "category",
        label: "CATEGORY",
        sortable: false,
        render: (temp, all) => <div>{all?.categoryObj?.name}</div>,
      },
      {
        key: "priority",
        label: "SUB-CATEGORY",
        sortable: false,
        render: (temp, all) => <div>{all?.subCategoryObj?.name}</div>,
      },
      {
        key: "status",
        label: "STATUS",
        sortable: false,
        render: (temp, all) => <div>{<StatusPill status={all?.status} />}</div>,
      },
      {
        key: "action",
        label: "action",
        sortable: false,
        render: (temp, all) => (
          <div>
            <IconButton
              className={"tableActionBtn"}
              color="secondary"
              disabled={isCalling}
              onClick={() => {
                handleViewUpdate(all);
              }}
            >
              <Edit fontSize={"small"} />
            </IconButton>
          </div>
        ),
      },
    ];
  }, [renderStatus, renderFirstCell, handleEdit, isCalling]);

  const tableData = useMemo(() => {
    const datatableFunctions = {
      onSortOrderChange: handleSortOrderChange,
      onPageChange: handlePageChange,
      // onRowSelection: this.handleRowSelection,
      onRowSizeChange: handleRowSize,
    };

    const datatable = {
      ...Constants.DATATABLE_PROPERTIES,
      columns: tableStructure,
      data: data,
      count: allData.length,
      page: currentPage,
    };

    return { datatableFunctions, datatable };
  }, [
    allData,
    tableStructure,
    handleSortOrderChange,
    handlePageChange,
    handleRowSize,
    data,
    currentPage,
  ]);

  return (
    <div>
      <PageBox>
        <div className={styles.headerContainer}>
          <div>
            <ButtonBase >
              <span className={"capitalize"}>
                <span className={styles.title}>Primary User Update List</span>
              </span>
            </ButtonBase>
            <div className={styles.newLine} />
          </div>
        </div>

        <div>
          <FilterComponent
            is_progress={isFetching}
            filters={[]}
            query={query}
            handleSearchValueChange={handleSearchValueChange}
            handleFilterDataChange={handleFilterDataChange}
          />
          <div>
            <br />
            <div style={{ width: "100%" }}>
              <DataTables
                {...tableData.datatable}
                {...tableData.datatableFunctions}
              />
            </div>
          </div>
        </div>
      </PageBox>

    </div>
  );
};

export default PrimaryUserUpdateListView;
